module.exports = __webpack_public_path__ + "static/media/blueLogo.0a8891e5.png";